<!-- 建议新建单独组件 -- components/MyEltable/index.vue -->

<!--
  ShowOnly:ture  仅展示
 tip: false   true 动态宽度
 -->
<template>
  <div>
    <div v-if="isSlot" class="oper-switch">
      <el-switch
        v-model="ExpandBar"
        @change="openOper"
        active-text="展开操作栏"
      >
      </el-switch>
    </div>
    <el-table
      @selection-change="_handleSelectionChange"
      :data="tableData"
      :span-method="tableInfo.listSpan ? listSpan : () => {}"
      border
      fit
      ref="payData"
      :stripe="stripe"
      :header-cell-class-name="headerRowStyle"
      :row-style="{
        height: tableInfo.rowheight ? tableInfo.rowheight : '50px'
      }"
      :cell-style="editStyle"
      @cell-click="_getMyData"
      highlight-current-row
      :height="maxHeight"
      @row-dblclick="rowDblclick"
      @row-click="handleRowClick"
      v-loading="buildTableInfo.loading"
      element-loading-text="拼命加载中"
      :default-sort="{}"
      v-on="$listeners"
      @sort-change="_sortChange"
      :class="{ 'customer-no-border-table': buildTableInfo.className }"
      row-key="ID"
      :tree-props="{ children: 'List', hasChildren: 'hasList' }"
      :row-class-name="tableRowClassName"
      :header-cell-style="{
        background: background,
        color: color,
        height: height
      }"
      :style="{
        'max-width': buildTableInfo.width,
        'min-width': buildTableInfo.MinWidth
      }"
      @select="handleSelection"
      @select-all="handleSelection"
    >
      <!-- 是否需要全选， isShow-->
      <el-table-column
        v-if="buildTableInfo.isShow"
        type="selection"
        align="center"
        :key="Math.random()"
        :selectable="selected"
        fixed
      >
      </el-table-column>
      <el-table-column
        v-else-if="buildTableInfo.BatchAnnotation"
        type="selection"
        align="center"
        :key="Math.random().toString()"
        :selectable="BatchAnnotationSelection"
        fixed
      >
      </el-table-column>
      <!-- prop: 字段名name, label: 展示的名称, fixed: 是否需要固定(left, right), minWidth: 设置列的最小宽度(不传默认值),
        oper: 是否有操作列, oper.name: 操作列字段名称, oper.clickFun: 操作列点击事件 -->
      <!-- :show-overflow-tooltip='th.show' -->
      <template v-for="(th, key) in buildTableInfo.tableHeader">
        <!-- <div> -->
        <!-- :width="th.width" -->
        <el-table-column
          :key="key + Math.random().toString()"
          v-if="th.prop !== 'oper' || ExpandBar || th.isSlot"
          :sortable="th.sortable"
          :label="th.label"
          :type="th.type"
          :min-width="th.minWidth"
          :table-column="th.table"
          align="center"
          :fixed="th.fixed"
          :formatter="_stateFormat"
          :prop="th.prop"
        >
          <template slot-scope="scope">
            <!-- 进行判断 如果有th.oper 表示操作这一列 -->
            <div v-if="th.oper" style="border: none">
              <el-button
                v-for="(o, key) in th.oper"
                :key="key"
                @click="o.clickFun(scope.row)"
                :type="o.type"
                :icon="o.icon"
                size="small"
                >{{ o.name }}
              </el-button>
            </div>
            <div v-else-if="th.operation" class="styleList">
              <div v-for="(o, key) in scope.row[th.prop]" :key="key">
                <el-button
                  :type="o.type"
                  :icon="o.icon"
                  @click="o.clickFun(scope.row)"
                >
                  {{ o.name }}
                </el-button>
              </div>
            </div>
            <!-- 判断 父级元素 及 本身元素宽度 -->
            <div
              class="Omit"
              v-else-if="th.tip && !th.ShowOnly && !th.setData && !th.custom"
            >
              <el-tooltip
                class="reasonPopper"
                placement="top"
                :content="scope.row[th.prop]"
                :disabled="isShowTooltip"
              >
                <div
                  class="linkTo"
                  @mouseover="onMouseOver(scope.row[th.prop] + scope.row['ID'])"
                >
                  <span :ref="scope.row[th.prop] + scope.row['ID']">{{
                    scope.row[th.prop]
                  }}</span>
                </div>
              </el-tooltip>
            </div>
            <!-- 显示数据过多时候  -->
            <div v-else-if="th.DataOverload === true">
              <el-tooltip placement="top">
                <div class="DataOverloadStyle" slot="content">
                  <span>{{ scope.row[th.prop] }}</span>
                </div>
                <div
                  class="DataStyle"
                  @mouseover="onOverload(scope.row[th.prop] + scope.row['ID'])"
                  :ref="scope.row[th.prop] + scope.row['ID']"
                >
                  {{ scope.row[th.prop] }}
                </div>
              </el-tooltip>
            </div>
            <!-- 设置 v-slot -->
            <slot v-else-if="th.custom" :name="th.prop" v-bind="scope"></slot>
            <!-- 没有特殊需求的数据显示 -->
            <span v-else-if="th.ShowOnly">{{ scope.row[th.prop] }}</span>
            <!-- 设置图片 -->
            <div v-else-if="th.prop == 'LogoPicOSSUrl'">
              <img
                style="width:58px;height:37px"
                :src="scope.row[th.prop]"
                alt=""
              />
            </div>
            <!-- 设置日期 -->
            <div v-else-if="th.setData">
              <template v-if="!th.formData">
                {{ FormUtil.dateFormat(scope.row[th.prop]) }}
              </template>
              <template v-else-if="th.formData">
                {{ FormUtil.dateFormat(scope.row[th.prop], th.formData) }}
              </template>
            </div>
            <!-- 其他 -->
            <div class="Omit" v-else>
              <el-tooltip placement="top">
                <div slot="content">
                  <span>{{ scope.row[th.prop] }}</span>
                </div>
                <div>
                  <div class="Omit">
                    <span>{{ scope.row[th.prop] }}</span>
                  </div>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { getInfo } from "@/utils/auth";
import FormUtil from "./utils";
export default {
  name: "MyTable",
  // 传入的数据
  props: {
    tableData: {
      // 表格数据
      type: Array,
      default: () => []
    },
    background: { type: String, default: "#FAFAFA" }, //背景色
    color: { type: String, default: "#313131" }, //字体颜色
    height: { type: String, default: "45px" }, //高度
    maxHeight: { type: String, default: "547" }, // 高度
    stripe: { type: Boolean, default: true }, // 斑马纹表格
    changeTableStyle: { type: String, default: "false" }, // 更改表格列的样式 配合下面数组使用
    columnIndex: [], // 默认为空  控制哪几个颜色需要改变
    tableInfo: {
      type: Object,
      default: function() {
        return {};
      }
    },
    rowDblclick: {
      // 单行单元格双击时，点击事件
      type: Function,
      default: (row, event, column) => {}
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    // 重组
    const buildTableInfo = FormUtil.buildForm(this.tableInfo);
    return {
      buildTableInfo: buildTableInfo, // 重构得数据
      ExpandBar: false, // 展开操作栏
      SelectRow: "", // 修改样式
      isShowTooltip: false,
      contentHover: "",
      checkboxdata: {
        value: ""
      },
      selectionChangeList: [],
      tableRef: null,
      FormUtil
    };
  },

  mounted() {
    this.tableRef = this.$refs.payData;
    this.stripe;
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["payData"].doLayout();
    });
  },
  beforeMount() {
    // 页面窗口改变触发_doLayout
    window.addEventListener("resize", this._doLayout);
  },
  watch: {
    $route: {
      handler(to) {
        // console.log(to.name, this.routerName);
        if (to.name === this.routerName) {
          // 解决fixed activated后样式错乱问题(方案就是恰当的时机执行doLayout)
          if (!this.tableRef) return;
          const timer = setInterval(() => {
            const element = this.tableRef.$el;
            if (element.offsetWidth > 0 && element.offsetHeight > 0) {
              // 元素显示
              clearInterval(timer);
              this._doLayout();
            }
          }, 100);
        }
      }
    },
    columns: {
      handler() {
        // 配置改变重新渲染table
        // console.log("myTable配置发生改变！");
        this.refreshColumns();
      }
    }
  },
  computed: {
    isSlot() {
      return (
        this.buildTableInfo.tableHeader &&
        this.buildTableInfo.tableHeader.filter(item => {
          return item.prop === "oper" && !item.isSlot;
        }).length > 0
      );
    }
  },
  methods: {
    close() {
      this.buildTableInfo.loading = false;
    },
    open() {
      this.buildTableInfo.loading = true;
    },
    // 重新布局
    _doLayout() {
      // 切换时让table滚动到最上面去, 执行doLayout方法,解决fixed问题
      // 有时候在掉接口途中页面被销毁、自定义列表内容，这个时候就找不到ref了 需要return
      if (!this.tableRef) return;
      this.tableRef.$el.querySelector(".el-table__body-wrapper").scrollTop = 0;
      this.$nextTick(() => {
        this.tableRef.doLayout();
      });
    },
    refreshColumns() {
      this._doLayout();
    },
    // 选择某行数据
    handleSelection(selection, row) {
      this.$emit("handleSelection", selection);
    },
    onMouseOver(str) {
      const tag = this.$refs[str];
      if (tag.length > 0) {
        const parentWidth = tag[0].parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag[0].offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
        // 鼠标悬停后显示的内容;
        this.contentHover = str;
      } else {
        const parentWidth = tag.parentNode.offsetWidth; // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth; // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth;
        // 鼠标悬停后显示的内容
        this.contentHover = str;
      }
    },
    /**
     * 处理 文字问题
     */
    onOverload(str) {
      const tag = this.$refs[str];
      // console.log(tag[0].parentNode.parentNode);
      // console.log(tag[0]);
      const parentWidth = tag[0].parentNode.parentNode.offsetWidth; // 获取元素父级可视宽度
      const contentWidth = tag[0].offsetWidth; // 获取元素可视宽度
      // console.log(parentWidth);
      // console.log(contentWidth);
      if (parentWidth > contentWidth) {
        tag[0].style.width = `${parentWidth}px`;
      }
    },
    // 表格勾选，选中改变的时候
    _handleSelectionChange(val) {
      // console.log(val);
      // 判断是否全选 是全选返回 true 不是则 false
      const res = this.$refs.payData.store.states.isAllSelected;
      this.$emit("selectList", val, res);
      this.checkboxdata.value = [...val];
      this.selectionChangeList = val;
    },
    _stateFormat(row, column, cellValue) {
      if (row.flag) {
        if (!cellValue) return "";
        if (cellValue.length > 8) {
          // 超过contentLength长度的内容隐藏
          return cellValue.slice(0, 8) + "...";
        }
        return cellValue;
      } else {
        return cellValue;
      }
    },
    //  调用，则表示选中当前页面所有数据
    tableSelect() {
      this.$refs.payData.toggleAllSelection();
    },
    listSpan({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === this.pageSize + 1) {
        if (columnIndex === 0) {
          return [1, 2, 3, 4, 5, 6, 7, 8];
        }
      }
    },
    // 排序方法
    _sortChange(val) {
      const { column, prop, order } = val;
      // console.log(val);
      this.$emit("sortChange", { column, prop, order });
    },
    // 获取选择行数信息
    _getMyData(row, column) {
      this.$emit("visitNoteClick", { row, column });
      this.$emit("func", { row, column });
    },
    // 修改组件表格样式
    editStyle(column) {
      if (
        this.changeTableStyle == "true" &&
        this.tableInfo.columnIndex.includes(column.columnIndex)
      ) {
        return {
          cursor: "pointer",
          color: "#5691f2",
          fontSzie: "12px"
        };
      } else {
        return {};
      }
    },
    // 修改表头得样式
    tableHeaderCellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle1 = "color: #fff;background:#fff;fontsize:50px";
      if (columnIndex >= 0 && columnIndex < 9 && rowIndex === 1) {
        return cellStyle1;
      }
    },
    // 修改表头样式
    headerRowStyle(obj) {
      if (!this.tableInfo.isheaderCell) {
        return "headerStyle";
      } else {
        return "headerStyle2";
      }
    },
    // 修改行样式
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex; //浅拷贝，让row有index
      if (row.IsDisable) {
        return "warning-row";
      } else {
        return "";
      }
    },
    // 点击表格行触发事件
    handleRowClick(row, column, e) {
      this.SelectRow = row.index;
      this.$emit("handleRow", row, column, e);
    },
    // 选择是否禁选
    selected(row, index) {
      if (row.RedemptionStatus == 1 || row.IsDisable == 1) {
        return true; //可选择
      } else {
        return false; //不可选择
      }
    },
    BatchAnnotationSelection(row, index) {
      const userInfo = getInfo();
      this.userID = userInfo.UserID;
    },
    openOper(val) {
      // console.log(val, "展开操作栏");
    }
  }
};
</script>

<style lang="less" scoped>
// 展开操作栏
.oper-switch {
  width: 100%;
  text-align: right;
  margin-bottom: 10px;
}
.el-table .cells {
  white-space: pre-line !important;
}

.el-table_1_column_4 /deep/ .cells {
  white-space: pre-line !important;
}

.styleList {
  display: flex;
  justify-content: center;
}

/* 表格内部 每一个得margin */
.el-table td.el-table__cell div {
  margin: 0px;
}

.Omit {
  max-width: 100%;
  /*强制文本在一行内显示*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(204, 200, 200, 0.2);
  border-radius: 5px;
}

/*表格最外层边框-底部边框*/
.customer-no-border-table .el-table--border::after,
.customer-no-border-table .el-table--group::after {
  width: 0 !important;
}

.customer-no-border-table::before {
  width: 0 !important;
}

.customer-no-border-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0 !important;
}

.customer-no-border-table .el-table__header tr th {
  background: #fff !important;
  color: #333333 !important;
  padding: 3px !important;
  font-weight: 550 !important;
  height: 36px !important;
  border: 0px !important;
  font-size: 15px !important;
}

.svg-icon /deep/ {
  width: 20px !important;
  height: 20px !important;
}

.试剂盘管理menu /deep/ {
  stroke: #656565 !important;
  fill: white;
}

.客户管理menu /deep/ {
  stroke: #656565 !important;
  fill: none;
}

.回访管理menu /deep/ {
  stroke: #656565 !important;
  fill: none;
}

.系统管理menu /deep/ {
  stroke: #656565 !important;
  fill: none;
}

.报表管理menu /deep/ {
  stroke: #656565 !important;
  fill: none;
}

.下载中心menu /deep/ {
  stroke: #656565 !important;
  fill: none;
}

.仪器管理menu /deep/ {
  stroke: #656565 !important;
  fill: #656565;
}

.代理商管理menu /deep/ {
  stroke: #656565 !important;
  fill: #656565;
}

.订单管理menu /deep/ {
  stroke: #656565 !important;
  fill: #656565;
}

.配置管理menu /deep/ {
  stroke: #656565 !important;
  fill: #656565;
}

.运维管理menu /deep/ {
  stroke: #656565 !important;
  fill: white;
}

.日志管理menu /deep/ {
  stroke: #656565 !important;
  fill: white;
}

.Lis管理menu /deep/ {
  stroke: #656565 !important;
  fill: white;
}

.废盘管理menu /deep/ {
  stroke: #656565;
  fill: none;
}

.DataOverloadStyle {
  max-height: 100px;
  overflow-y: scroll;
}

.DataStyle {
  width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.linkTo {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/deep/ .cell {
  display: flex;
  justify-content: center;
  align-items: center;
  // color: #313131;

  .styleList {
    margin-left: 5px !important;
  }
}

.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 50px !important;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  // height: 50px;
}
</style>
<style>
/* 改变表格 背景颜色 */
.el-table .warning-row {
  background: #5f6774 !important;
  color: #313131 !important;
  border: 1px solid #5f6774 !important;
}
.el-table .success-row {
  background-color: #54e407 !important;
}

.el-table td,
.el-table th {
  padding: 0px !important;
  height: 50px;
  box-sizing: content-box;
}
.el-tooltip__popper {
  max-width: 250px !important;
}

.el-tooltip__popper,
.el-tooltip__popper.is-dark {
  max-width: 145px !important;
  /* line-height: 24px; */
  color: #fff !important;
  background-color: rgb(48, 65, 86) !important;
}

.headerStyle2 {
  color: #313131 !important;
  background: #fff !important;
  height: 56px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TableRealy/BasicForm.vue